<template>
  <div
    v-if="value"
    class="modal-overlay"
    @click.self="close"
  >
    <div ref="modal" class="modal-content">
      <div class="close-button" @click="close">
        <CloseIcon />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
  import CloseIcon from '@/assets/img/icons/close.svg?inline'

  export default {
    name: 'Modal',
    components: { CloseIcon },
    props: {
      value: Boolean
    },
    watch: {
      value (isOpen) {
        if (isOpen) {
          this.$nextTick(() => {
            const el = this.$refs.modal.querySelector(
              'input, textarea, select, button, [tabindex]:not([tabindex="-1"])'
            )
            el && el.focus()
          })
        }
      }
    },
    methods: {
      close () {
        this.$emit('input', false)
      }
    }
  }
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  padding: 0 20px;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  background: white;
  padding: 24px 16px 16px 16px;
  border-radius: 8px;
  min-width: 300px;
  max-width: 450px;
}

.close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
  z-index: 3;
  width: 16px;
  height: 16px;
}
</style>
